import {
  getOvertimeListPath,
  createOvertimePath,
  updateOvertimePath,
  deleteOvertimePath,
  assignEmployeeOvertimePath,
  getStaffListPath
} from "../../services/config";
import { useGlobalToast } from "../../stopOldToastGlobally.js";
import { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import "./Overtimesettings.css";
import {
  commonSaveData,
  initCommonState,
  commonGetDataFourth
} from "../../redux/slices/commonSlice";
import { config as axiosConfig } from "../../services/configHeader";
import { ToastContainer, toast } from "react-toastify";

// ─── Icons ────────────────────────────────────────────────────
const EditIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
);
const DeleteIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4h6v2" />
  </svg>
);
const AssignIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
    <polyline points="16 11 18 13 22 9" />
  </svg>
);
const PlusIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);
const BackIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const CloseIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const ChevronIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9" />
  </svg>
);
const ChevronLeftIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);
const ChevronRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const SearchIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

// ─── Avatar helpers ───────────────────────────────────────────
const AVATAR_COLORS = ["#4f7c6b", "#c4a020", "#7c4fc4", "#c44f7c", "#207cc4", "#4fc47c", "#c4204f", "#207c4f"];
const getAvatarColor = (name = "") => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
};
const getInitials = (name = "") => {
  const parts = name.trim().split(" ");
  return parts.length >= 2
    ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    : name.slice(0, 2).toUpperCase();
};

// ─── Pagination ───────────────────────────────────────────────
const Pagination = ({ total, rowsPerPage, page, onPage, onRowsChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / rowsPerPage));
  const getPages = () => {
    const pages = [];
    if (totalPages <= 7) { for (let i = 1; i <= totalPages; i++) pages.push(i); }
    else {
      pages.push(1);
      if (page > 3) pages.push("...");
      for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) pages.push(i);
      if (page < totalPages - 2) pages.push("...");
      pages.push(totalPages);
    }
    return pages;
  };
  return (
    <div className="ot-pagination">
      <button className="ot-page-arrow-btn" onClick={() => onPage(page - 1)} disabled={page === 1}>
        <ChevronLeftIcon />
      </button>
      {getPages().map((p, i) => {
        const key = p === "..." ? `dots-${i}` : `page-${p}`;
        return p === "..." ? (
          <span key={key} className="ot-pagination-dots">…</span>
        ) : (
          <button key={key} className={`ot-page-num${p === page ? " active" : ""}`} onClick={() => onPage(p)}>
            {p}
          </button>
        );
      })}
      <button className="ot-page-arrow-btn" onClick={() => onPage(page + 1)} disabled={page === totalPages}>
        <ChevronRightIcon />
      </button>
      <div className="ot-rows-select-wrap">
        <select className="ot-rows-select" value={rowsPerPage}
          onChange={e => { onRowsChange(Number(e.target.value)); onPage(1); }}>
          {[10, 20, 50, 100].map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <span className="ot-select-chevron"><ChevronIcon /></span>
      </div>
    </div>
  );
};

// ─── RadioRow ─────────────────────────────────────────────────
const RadioRow = ({ id, label, subtitle, checked, onChange, children }) => (
  <label htmlFor={id} className={`ot-radio-row${checked ? " checked" : ""}`}>
    <div className="ot-radio-left">
      <div className={`ot-radio-dot-outer${checked ? " checked" : ""}`}>
        {checked && <div className="ot-radio-dot-inner" />}
      </div>
      <div>
        <div className={`ot-radio-label${checked ? " checked" : ""}`}>{label}</div>
        {subtitle && <div className="ot-radio-sub">{subtitle}</div>}
      </div>
    </div>
    {children && <div onClick={e => e.stopPropagation()}>{children}</div>}
    <input type="radio" id={id} checked={checked} onChange={onChange} style={{ display: "none" }} />
  </label>
);

// ─── OTSettingsForm ───────────────────────────────────────────
const OTSettingsForm = ({ initialData, onSave, onCancel }) => {
  // Log the initialData to see what we're receiving
  console.log("OTSettingsForm initialData:", initialData);

  // Helper function to determine if eligibility is custom (not "1" or "2")
  const isCustomEligibility = (val) => {
    return val && val !== "1" && val !== "2";
  };

  // Overtime Eligibility
  const [eligibility, setEligibility] = useState(() => {
    const val = initialData?.overtimeEligibility;
    if (!val && val !== "") return ""; // No default selection
    if (val === "1" || val === "2") return val;
    if (isCustomEligibility(val)) return "3"; // Custom
    return "";
  });
  
  const [customHours, setCustomHours] = useState(() => {
    const val = initialData?.overtimeEligibility;
    if (isCustomEligibility(val)) {
      return val.toString();
    }
    return "";
  });

  // Handle number-only input for custom hours
  const handleCustomHoursChange = (e) => {
    const value = e.target.value;
    // Only allow numbers
    if (value === "" || /^\d+$/.test(value)) {
      setCustomHours(value);
      if (formErrors.customHours) setFormErrors({ ...formErrors, customHours: null });
    }
  };

  // Minimum Overtime Block
  const isCustomMinBlock = (raw) => {
    return raw && raw !== "30" && raw !== "60";
  };
  
  const [minBlock, setMinBlock] = useState(() => {
    const raw = initialData?.minOvertimeBlock;
    if (!raw && raw !== "") return ""; // No default
    if (raw === "30" || raw === "60") return raw;
    if (isCustomMinBlock(raw)) return "custom";
    return "";
  });
  
  const [customMinutes, setCustomMinutes] = useState(() => {
    const raw = initialData?.minOvertimeBlock;
    if (isCustomMinBlock(raw)) {
      return String(raw);
    }
    return "";
  });

  // Handle number-only input for custom minutes
  const handleCustomMinutesChange = (e) => {
    const value = e.target.value;
    // Only allow numbers
    if (value === "" || /^\d+$/.test(value)) {
      setCustomMinutes(value);
      if (formErrors.customMinutes) setFormErrors({ ...formErrors, customMinutes: null });
    }
  };

  // Overtime Calculation
  const [calculation, setCalculation] = useState(() => {
    const raw = initialData?.overtimeCalc;
    console.log("Initial calculation value:", raw);
    
    if (!raw && raw !== "") return ""; // No default
    
    // Check if it's a multiplier (2x or 1.5x)
    if (raw === "2x") return "2x";
    if (raw === "1.5x") return "1.5x";
    
    // Check if it's a number (fixed amount)
    if (!isNaN(raw) && raw.toString().trim() !== "") {
      return "fixed";
    }
    
    // If it's anything else, it's custom
    if (raw && raw !== "") {
      return "custom";
    }
    
    return "";
  });
  
  const [fixedAmount, setFixedAmount] = useState(() => {
    const raw = initialData?.overtimeCalc;
    console.log("Initial fixedAmount value:", raw);
    
    // Check if it's a number (fixed amount)
    if (raw && !isNaN(raw) && raw.toString().trim() !== "") {
      return String(raw);
    }
    return "";
  });

  // Handle number-only input for fixed amount (allowing decimals)
  const handleFixedAmountChange = (e) => {
    const value = e.target.value;
    // Only allow numbers with optional decimal
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setFixedAmount(value);
      if (formErrors.fixedAmount) setFormErrors({ ...formErrors, fixedAmount: null });
    }
  };
  
  const [customRate, setCustomRate] = useState(() => {
    const raw = initialData?.overtimeCalc;
    console.log("Initial customRate value:", raw);
    
    // Check if it's custom (not 2x, not 1.5x, and not a number)
    if (raw && raw !== "2x" && raw !== "1.5x" && isNaN(raw)) {
      return String(raw);
    }
    return "";
  });

  // Handle number-only input for custom rate (allowing decimals)
  const handleCustomRateChange = (e) => {
    const value = e.target.value;
    // Only allow numbers with optional decimal
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setCustomRate(value);
      if (formErrors.customRate) setFormErrors({ ...formErrors, customRate: null });
    }
  };

  // Week Off Overtime
  const [weekOff, setWeekOff] = useState(() => {
    const val = initialData?.weekOffOvertime;
    return val || ""; // No default
  });
  
  // Approval Required
  const [approval, setApproval] = useState(() => {
    const val = initialData?.approveRequired;
    return val || ""; // No default
  });
  
  const [formErrors, setFormErrors] = useState({});

  // Effect to update form when initialData changes (for edit mode)
  useEffect(() => {
    console.log("initialData changed, updating form:", initialData);
    
    if (initialData && Object.keys(initialData).length > 0) {
      // Update eligibility
      const eligVal = initialData.overtimeEligibility;
      if (eligVal === "1" || eligVal === "2") {
        setEligibility(eligVal);
        setCustomHours("");
      } else if (eligVal && eligVal !== "") {
        setEligibility("3");
        setCustomHours(eligVal.toString());
      } else {
        setEligibility("");
        setCustomHours("");
      }
      
      // Update min block
      const minVal = initialData.minOvertimeBlock;
      if (minVal === "30" || minVal === "60") {
        setMinBlock(minVal);
        setCustomMinutes("");
      } else if (minVal && minVal !== "") {
        setMinBlock("custom");
        setCustomMinutes(minVal.toString());
      } else {
        setMinBlock("");
        setCustomMinutes("");
      }
      
      // Update calculation - FIXED THIS PART
      const calcVal = initialData.overtimeCalc;
      console.log("Updating calculation with value:", calcVal);
      
      if (calcVal === "2x") {
        console.log("Setting calculation to 2x");
        setCalculation("2x");
        setFixedAmount("");
        setCustomRate("");
      } else if (calcVal === "1.5x") {
        console.log("Setting calculation to 1.5x");
        setCalculation("1.5x");
        setFixedAmount("");
        setCustomRate("");
      } else if (calcVal && !isNaN(calcVal) && calcVal.toString().trim() !== "") {
        console.log("Setting calculation to fixed with amount:", calcVal);
        setCalculation("fixed");
        setFixedAmount(calcVal.toString());
        setCustomRate("");
      } else if (calcVal && calcVal !== "") {
        console.log("Setting calculation to custom with rate:", calcVal);
        setCalculation("custom");
        setFixedAmount("");
        setCustomRate(calcVal.toString());
      } else {
        console.log("Setting calculation to empty");
        setCalculation("");
        setFixedAmount("");
        setCustomRate("");
      }
      
      // Update week off
      if (initialData.weekOffOvertime) {
        setWeekOff(initialData.weekOffOvertime);
      } else {
        setWeekOff("");
      }
      
      // Update approval
      if (initialData.approveRequired) {
        setApproval(initialData.approveRequired);
      } else {
        setApproval("");
      }
    }
  }, [initialData]);

  // Log all state values to debug
  useEffect(() => {
    console.log("Current form state:", {
      eligibility,
      customHours,
      minBlock,
      customMinutes,
      calculation,
      fixedAmount,
      customRate,
      weekOff,
      approval
    });
  }, [eligibility, customHours, minBlock, customMinutes, calculation, fixedAmount, customRate, weekOff, approval]);

  const validateForm = () => {
    const errors = {};
    
    // Validate Overtime Eligibility
    if (!eligibility) {
      errors.eligibility = "Please select an overtime eligibility option";
    } else if (eligibility === "3") {
      if (!customHours) {
        errors.customHours = "Custom hours is required";
      } else if (isNaN(customHours) || Number(customHours) <= 0) {
        errors.customHours = "Enter a valid positive number";
      } else if (!/^\d+$/.test(customHours)) {
        errors.customHours = "Only whole numbers allowed";
      }
    }
    
    // Validate Minimum Overtime Block
    if (!minBlock) {
      errors.minBlock = "Please select a minimum overtime block";
    } else if (minBlock === "custom") {
      if (!customMinutes) {
        errors.customMinutes = "Custom minutes is required";
      } else if (isNaN(customMinutes) || Number(customMinutes) <= 0) {
        errors.customMinutes = "Enter a valid positive number";
      } else if (!/^\d+$/.test(customMinutes)) {
        errors.customMinutes = "Only whole numbers allowed";
      }
    }
    
    // Validate Overtime Calculation
    if (!calculation) {
      errors.calculation = "Please select an overtime calculation method";
    } else if (calculation === "fixed") {
      if (!fixedAmount) {
        errors.fixedAmount = "Fixed amount is required";
      } else if (isNaN(fixedAmount) || Number(fixedAmount) <= 0) {
        errors.fixedAmount = "Enter a valid positive amount";
      }
    } else if (calculation === "custom") {
      if (!customRate) {
        errors.customRate = "Custom rate is required";
      } else if (isNaN(customRate) || Number(customRate) <= 0) {
        errors.customRate = "Enter a valid positive rate";
      }
    }
    // 2x and 1.5x don't need additional validation
    
    // Validate Week Off Overtime
    if (!weekOff) {
      errors.weekOff = "Please select a week off overtime option";
    }
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = () => {
    if (!validateForm()) { 
      toast.error("Please fix the errors before saving"); 
      return; 
    }
    
    // Prepare overtimeEligibility value
    let overtimeEligibilityValue;
    if (eligibility === "3") {
      overtimeEligibilityValue = customHours;
    } else {
      overtimeEligibilityValue = eligibility;
    }
    
    // Prepare minOvertimeBlock value
    let minOvertimeBlockValue;
    if (minBlock === "custom") {
      minOvertimeBlockValue = customMinutes;
    } else {
      minOvertimeBlockValue = minBlock;
    }
    
    // Prepare overtimeCalc value
    let overtimeCalcValue;
    if (calculation === "fixed") {
      overtimeCalcValue = fixedAmount;
    } else if (calculation === "2x") {
      overtimeCalcValue = "2x";
    } else if (calculation === "1.5x") {
      overtimeCalcValue = "1.5x";
    } else if (calculation === "custom") {
      overtimeCalcValue = customRate;
    }

    // Log what we're saving
    const saveData = [{
      overtimeEligibility: overtimeEligibilityValue,
      minOvertimeBlock: minOvertimeBlockValue,
      overtimeCalc: overtimeCalcValue,
      weekOffOvertime: weekOff,
      approveRequired: approval
    }];
    
    console.log("Saving form data:", saveData);

    onSave(saveData);
  };

  return (
    <div className="ot-settings-form">
      <div className="ot-form-grid">
        <div>
          <p className="ot-section-title">Overtime Eligibility <span className="required-star">*</span></p>
          <div className="ot-radio-stack">
            <RadioRow id="elig-1" label="After Gross Hours" checked={eligibility === "1"} onChange={() => {
              setEligibility("1");
              if (formErrors.eligibility) setFormErrors({ ...formErrors, eligibility: null });
            }} />
            <RadioRow id="elig-2" label="After Mandatory Hours" checked={eligibility === "2"} onChange={() => {
              setEligibility("2");
              if (formErrors.eligibility) setFormErrors({ ...formErrors, eligibility: null });
            }} />
            <RadioRow id="elig-3" label="After Custom Hours" checked={eligibility === "3"} onChange={() => {
              setEligibility("3");
              if (formErrors.eligibility) setFormErrors({ ...formErrors, eligibility: null });
            }}>
              <div className="ot-mini-input-wrap">
                <input 
                  type="text"
                  inputMode="numeric"
                  pattern="\d*"
                  className={`ot-mini-input${formErrors.customHours ? " error" : ""}`}
                  placeholder="Hours" 
                  value={customHours}
                  onChange={handleCustomHoursChange}
                  onClick={() => {
                    setEligibility("3");
                    if (formErrors.eligibility) setFormErrors({ ...formErrors, eligibility: null });
                  }} 
                />
                <span className="ot-mini-input-label">hrs</span>
              </div>
            </RadioRow>
            {formErrors.eligibility && <div className="ot-error-text">{formErrors.eligibility}</div>}
            {formErrors.customHours && <div className="ot-error-text">{formErrors.customHours}</div>}
          </div>
        </div>
        
        <div>
          <p className="ot-section-title">Minimum Overtime Block <span className="required-star">*</span></p>
          <div className="ot-radio-stack">
            <RadioRow id="min-30" label="30 minutes" checked={minBlock === "30"} onChange={() => {
              setMinBlock("30");
              if (formErrors.minBlock) setFormErrors({ ...formErrors, minBlock: null });
            }} />
            <RadioRow id="min-60" label="1 hour" checked={minBlock === "60"} onChange={() => {
              setMinBlock("60");
              if (formErrors.minBlock) setFormErrors({ ...formErrors, minBlock: null });
            }} />
            <RadioRow id="min-custom" label="Custom Minutes" checked={minBlock === "custom"} onChange={() => {
              setMinBlock("custom");
              if (formErrors.minBlock) setFormErrors({ ...formErrors, minBlock: null });
            }}>
              <input 
                type="text"
                inputMode="numeric"
                pattern="\d*"
                className={`ot-mini-input${formErrors.customMinutes ? " error" : ""}`}
                placeholder="Minutes" 
                value={customMinutes}
                onChange={handleCustomMinutesChange}
                onClick={() => {
                  setMinBlock("custom");
                  if (formErrors.minBlock) setFormErrors({ ...formErrors, minBlock: null });
                }} 
              />
            </RadioRow>
            {formErrors.minBlock && <div className="ot-error-text">{formErrors.minBlock}</div>}
            {formErrors.customMinutes && <div className="ot-error-text">{formErrors.customMinutes}</div>}
          </div>
        </div>
      </div>
      
      <div className="ot-form-grid">
        <div>
          <p className="ot-section-title">Overtime Calculation <span className="required-star">*</span></p>
          <div className="ot-radio-stack">
            <RadioRow id="calc-fixed" label="Per hour fixed" checked={calculation === "fixed"} onChange={() => {
              setCalculation("fixed");
              if (formErrors.calculation) setFormErrors({ ...formErrors, calculation: null });
            }}>
              <div className="ot-mini-input-wrap">
                <span className="ot-currency">₹</span>
                <input 
                  type="text"
                  inputMode="decimal"
                  className={`ot-mini-input${formErrors.fixedAmount ? " error" : ""}`}
                  placeholder="Amount" 
                  value={fixedAmount}
                  onChange={handleFixedAmountChange}
                  onClick={() => {
                    setCalculation("fixed");
                    if (formErrors.calculation) setFormErrors({ ...formErrors, calculation: null });
                  }} 
                />
              </div>
            </RadioRow>
            {formErrors.fixedAmount && <div className="ot-error-text">{formErrors.fixedAmount}</div>}
            
            <RadioRow id="calc-2x" label="2× hourly rate" checked={calculation === "2x"} onChange={() => {
              setCalculation("2x");
              // Clear other values
              setFixedAmount("");
              setCustomRate("");
              if (formErrors.calculation) setFormErrors({ ...formErrors, calculation: null });
            }} />
            
            <RadioRow id="calc-1.5x" label="1.5× hourly rate" checked={calculation === "1.5x"} onChange={() => {
              setCalculation("1.5x");
              // Clear other values
              setFixedAmount("");
              setCustomRate("");
              if (formErrors.calculation) setFormErrors({ ...formErrors, calculation: null });
            }} />
            
            <RadioRow id="calc-custom" label="Custom multiplier" checked={calculation === "custom"} onChange={() => {
              setCalculation("custom");
              // Clear fixed amount
              setFixedAmount("");
              if (formErrors.calculation) setFormErrors({ ...formErrors, calculation: null });
            }}>
              <input 
                type="text"
                inputMode="decimal"
                className={`ot-mini-input${formErrors.customRate ? " error" : ""}`}
                placeholder="e.g. 1.75" 
                value={customRate}
                onChange={handleCustomRateChange}
                onClick={() => {
                  setCalculation("custom");
                  if (formErrors.calculation) setFormErrors({ ...formErrors, calculation: null });
                }} 
              />
            </RadioRow>
            {formErrors.calculation && <div className="ot-error-text">{formErrors.calculation}</div>}
            {formErrors.customRate && <div className="ot-error-text">{formErrors.customRate}</div>}
          </div>
        </div>
        
        <div>
          <p className="ot-section-title">Week Off Overtime <span className="required-star">*</span></p>
          <div className="ot-radio-stack">
            <RadioRow id="wo-1" label="Count as normal OT" checked={weekOff === "1"} onChange={() => {
              setWeekOff("1");
              if (formErrors.weekOff) setFormErrors({ ...formErrors, weekOff: null });
            }} />
            <RadioRow id="wo-2" label="Double pay" checked={weekOff === "2"} onChange={() => {
              setWeekOff("2");
              if (formErrors.weekOff) setFormErrors({ ...formErrors, weekOff: null });
            }} />
            <RadioRow id="wo-3" label="Full Day Pay" checked={weekOff === "3"} onChange={() => {
              setWeekOff("3");
              if (formErrors.weekOff) setFormErrors({ ...formErrors, weekOff: null });
            }} />
            <RadioRow id="wo-4" label="Comp Off" checked={weekOff === "4"} onChange={() => {
              setWeekOff("4");
              if (formErrors.weekOff) setFormErrors({ ...formErrors, weekOff: null });
            }} />
            {formErrors.weekOff && <div className="ot-error-text">{formErrors.weekOff}</div>}
          </div>
        </div>
      </div>
      
      <div className="ot-form-grid">
        <div>
          <p className="ot-section-title">Approval Required</p>
          <div className="ot-radio-stack">
            <RadioRow 
              id="appr-manager" 
              label="Yes — Manager Approval" 
              subtitle="OT pending until approved" 
              checked={approval === "1"} 
              onChange={() => setApproval("1")} 
            />
            <RadioRow 
              id="appr-auto" 
              label="Auto Approved" 
              subtitle="OT calculated automatically" 
              checked={approval === ""} 
              onChange={() => setApproval("")} 
            />
          </div>
          {/* <p className="ot-field-hint">Optional - leave unchecked if not required</p> */}
        </div>
      </div>
      
      <div className="ot-form-footer">
        <button className="ot-btn-cancel" onClick={onCancel}>Cancel</button>
        <button className="ot-btn-save" onClick={handleSave}>Save Settings</button>
      </div>
    </div>
  );
};

// ─── OTModal ──────────────────────────────────────────────────
const OTModal = ({ title, onClose, children }) => (
  <div className="ot-overlay">
    <div className="ot-modal">
      <div className="ot-modal-header">
        <h2 className="ot-modal-title">{title}</h2>
        <button className="ot-modal-close" onClick={onClose}><CloseIcon /></button>
      </div>
      <div className="ot-modal-body">{children}</div>
    </div>
  </div>
);

// ─── AssignModal ──────────────────────────────────────────────
const AssignModal = ({ module, onClose, onSave }) => {
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);

  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState("");
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const user = JSON.parse(localStorage.getItem("user_data")) || { user_id: 2 };

  useEffect(() => {
    if (!module?.overTimeId) { toast.error("Invalid module data"); return; }
    setLoading(true);
    const endpoint = `admin/getStaffList?userId=${user?.user_id || 2}&shiftId=0&branchId=0&departmentId=0`;
    dispatch(commonGetDataFourth(endpoint));
  }, [dispatch, user?.user_id, module?.overTimeId]);

  useEffect(() => {
    if (commonState.commonGetFourthSuccess) {
      const response = commonState.commonGetFourthData;
      let employeeData = [];
      if (response?.data && Array.isArray(response.data)) {
        employeeData = response.data;
      } else if (Array.isArray(response)) {
        employeeData = response;
      }

      const normalizedEmployees = employeeData.map(emp => ({
        staffId: emp.staffId || emp.staff_id,
        employeeId: emp.employee_id || emp.employeeId,
        name: emp.full_name || emp.name,
        full_name: emp.full_name,
        employee_id: emp.employee_id,
        ...emp
      }));
      setEmployees(normalizedEmployees);

      let assignedIds = [];
      if (module?.assignedEmployees) {
        if (Array.isArray(module.assignedEmployees)) {
          assignedIds = module.assignedEmployees;
        } else if (typeof module.assignedEmployees === "string") {
          assignedIds = module.assignedEmployees.split(",").map(id => id.trim()).filter(id => id !== "");
        }
      }
      setSelected(assignedIds.map(String));
      dispatch(initCommonState());
      setLoading(false);
    }

    if (commonState.commonGetFourthError) {
      toast.error("Failed to fetch employees: " + (commonState.commonGetFourthMessage || "Unknown error"));
      setLoading(false);
    }
  }, [
    commonState.commonGetFourthSuccess,
    commonState.commonGetFourthError,
    commonState.commonGetFourthMessage,
    commonState.commonGetFourthData,
    dispatch,
    module,
  ]);

  const filtered = employees.filter(e => {
    const q = search.toLowerCase();
    return (
      (e.full_name || e.name || "").toLowerCase().includes(q) ||
      (e.employee_id || e.employeeId || "").toLowerCase().includes(q)
    );
  });

  const allSelected = filtered.length > 0 && filtered.every(e =>
    selected.includes(String(e.staffId || e.staff_id))
  );

  const toggleAll = () => {
    if (allSelected) {
      setSelected(p => p.filter(id => !filtered.find(e => String(e.staffId || e.staff_id) === id)));
    } else {
      const newIds = filtered.map(e => String(e.staffId || e.staff_id));
      setSelected(p => [...new Set([...p, ...newIds])]);
    }
  };

  const toggleOne = (id) => {
    const s = String(id);
    setSelected(p => p.includes(s) ? p.filter(x => x !== s) : [...p, s]);
  };

  const removeOne = (id, e) => {
    e.stopPropagation();
    setSelected(p => p.filter(x => x !== String(id)));
  };

const handleSave = async () => {
  if (!module?.overTimeId) { toast.error("Invalid module data"); return; }
  if (selected.length === 0) { toast.warning("Please select at least one employee"); return; }

  setSaveLoading(true);
  const baseUrl = (process.env.REACT_APP_BASE_URI || "").replace(/\/$/, "");

  try {
    // ── FIX: backend expects 'staffId' not 'staffId[]' ──
    // Send as comma-separated string since backend reads $input['staffId']
    const formData = new URLSearchParams();
    formData.append("userId",     String(user?.user_id || 2));
    formData.append("overTimeId", String(module.overTimeId));
    formData.append("staffId",    selected.join(",")); // ← comma-separated, not array

    const response = await axios.post(
      `${baseUrl}/${assignEmployeeOvertimePath}`,
      formData,
      {
        ...axiosConfig,
        headers: {
          ...axiosConfig?.headers,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    const result = response?.data;
    if (result && (result.status === true || result.status === "true" || result.code === 200)) {
      onSave(selected);
      toast.success(`Successfully assigned to ${selected.length} employee${selected.length > 1 ? "s" : ""}`);
      onClose();
    } else {
      toast.error(result?.message || "Failed to assign employees");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Assignment failed");
  } finally {
    setSaveLoading(false);
  }
};

  const selectedEmps = employees.filter(e => selected.includes(String(e.staffId || e.staff_id)));

  if (!module?.overTimeId) {
    return (
      <div className="ae-overlay">
        <div className="ae-modal">
          <div className="ae-header">
            <div className="ae-header-left">
              <button className="ae-close-btn" onClick={onClose}>✕</button>
              <h2 className="ae-header-title">Error</h2>
            </div>
          </div>
          <div className="ae-body"><div className="ae-empty">Invalid module data</div></div>
        </div>
      </div>
    );
  }

  return (
    <div className="ae-overlay">
      <div className="ae-modal">
        <div className="ae-header">
          <div className="ae-header-left">
            <button className="ae-close-btn" onClick={onClose}>✕</button>
            <h2 className="ae-header-title">Assign Employees</h2>
          </div>
          <button className="ae-save-btn" onClick={handleSave} disabled={saveLoading}>
            {saveLoading ? "Saving..." : `Save Changes${selected.length > 0 ? ` (${selected.length})` : ""}`}
          </button>
        </div>

        <div className="ae-body">
          <p className="ae-module-name">Module: <span>{module.overTimeName}</span></p>

          {selectedEmps.length > 0 && (
            <div className="ae-preview-strip">
              {selectedEmps.map((emp, i) => (
                <div
                  key={emp.staffId || emp.staff_id}
                  className="ae-preview-avatar"
                  title={`${emp.full_name || emp.name} — click to remove`}
                  style={{ background: getAvatarColor(emp.full_name || emp.name), zIndex: selectedEmps.length - i }}
                  onClick={(e) => removeOne(emp.staffId || emp.staff_id, e)}
                >
                  {getInitials(emp.full_name || emp.name)}
                  <span className="ae-preview-x">✕</span>
                </div>
              ))}
            </div>
          )}

          <div className="ae-filters">
            <div className="ae-search-wrap">
              <span className="ae-search-icon"><SearchIcon /></span>
              <input
                className="ae-search-input"
                placeholder="Search employees..."
                value={search}
                onChange={e => setSearch(e.target.value)}
              />
            </div>
          </div>

          {loading ? (
            <div className="ae-loading">Loading employees...</div>
          ) : (
            <>
              <div className="ae-select-all-row" onClick={toggleAll}>
                <div className={`ae-cb${allSelected ? " checked" : ""}`}>
                  {allSelected && <span className="ae-checkmark">✓</span>}
                </div>
                <span className="ae-cb-label">Select All</span>
              </div>

              {filtered.length === 0 ? (
                <div className="ae-empty">No employees found</div>
              ) : filtered.map(emp => {
                const empId = emp.staffId || emp.staff_id;
                const empName = emp.full_name || emp.name;
                const empCode = emp.employee_id || emp.employeeId;
                const isChecked = selected.includes(String(empId));
                return (
                  <div key={empId} className={`ae-emp-row${isChecked ? " checked" : ""}`} onClick={() => toggleOne(empId)}>
                    <div className="ae-avatar" style={{ background: getAvatarColor(empName) }}>
                      {getInitials(empName)}
                    </div>
                    <div className="ae-emp-info">
                      <div className="ae-emp-name">{empName}</div>
                      <div className="ae-emp-id">{empCode}</div>
                    </div>
                    <div className={`ae-checkbox${isChecked ? " checked" : ""}`}>
                      {isChecked && <span className="ae-checkmark">✓</span>}
                    </div>
                  </div>
                );
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// ─── AssignedAvatars ──────────────────────────────────────────
const AssignedAvatars = ({ assignedIds = [], employees = [] }) => {
  if (!assignedIds || assignedIds.length === 0) return null;
  const MAX = 5;
  const stringAssignedIds = assignedIds.map(String);
  const emps = employees.filter(e => {
    const empId = String(e.employeeId || e.staffId || e.staff_id || "");
    return empId && stringAssignedIds.includes(empId);
  });
  const visible = emps.slice(0, MAX);
  const overflow = emps.length - MAX;
  return (
    <div className="ot-avatar-strip">
      {visible.map((emp, i) => {
        const empName = emp.name || emp.full_name;
        const empId = emp.employeeId || emp.staffId || emp.staff_id;
        return (
          <div key={empId} title={empName} className="ot-avatar-item"
            style={{ background: getAvatarColor(empName), zIndex: MAX - i, marginLeft: i === 0 ? 0 : "-6px" }}>
            {getInitials(empName)}
          </div>
        );
      })}
      {overflow > 0 && <div className="ot-avatar-more" title={`+${overflow} more`}>+{overflow}</div>}
      <span className="ot-avatar-count">{emps.length} assigned</span>
    </div>
  );
};

// ─── parseModules helper ──────────────────────────────────────
// ─── parseModules helper ──────────────────────────────────────
// ─── parseModules helper ──────────────────────────────────────
const parseModules = (list) => {
  return list.map(mod => {
    let assignedEmployees = [];
    const rawStaff = mod.staff_id || mod.staffId || "";
    if (typeof rawStaff === "string" && rawStaff.trim()) {
      assignedEmployees = rawStaff.split(",").map(s => s.trim()).filter(Boolean);
    } else if (Array.isArray(rawStaff)) {
      assignedEmployees = rawStaff.map(String);
    }

    // ── Extract settings — try every possible key combination ──
    let rawSettings = null;

    if (Array.isArray(mod.details) && mod.details.length > 0) {
      rawSettings = mod.details[0];
    } else if (Array.isArray(mod.overTimeData) && mod.overTimeData.length > 0) {
      rawSettings = mod.overTimeData[0];
    } else if (mod.settings && typeof mod.settings === "object") {
      rawSettings = mod.settings;
    } else {
      // settings might be directly on the mod object
      rawSettings = mod;
    }

    const settings = {
      overtimeEligibility:
        rawSettings?.overtimeEligibility   ||
        rawSettings?.overtime_eligibility  ||
        rawSettings?.OvertimeEligibility   || "",

      minOvertimeBlock:
        rawSettings?.minOvertimeBlock      ||
        rawSettings?.min_overtime_block    ||
        rawSettings?.MinOvertimeBlock      || "",

      overtimeCalc:
        rawSettings?.overtimeCalc          ||
        rawSettings?.overtime_calc         ||
        rawSettings?.overtimeCalculation   ||
        rawSettings?.overtime_calculation  ||
        rawSettings?.OvertimeCalc          || "",

      weekOffOvertime:
        rawSettings?.weekOffOvertime       ||
        rawSettings?.weekoff_overtime      ||
        rawSettings?.week_off_overtime     ||
        rawSettings?.WeekOffOvertime       || "",

      approveRequired:
        rawSettings?.approveRequired       ||
        rawSettings?.approve_required      ||
        rawSettings?.ApproveRequired       || "",
    };

    console.log("Module:", mod.overTimeName, "→ rawSettings:", rawSettings, "→ settings:", settings);

    return {
      ...mod,
      overTimeId:        mod.overTimeId   || mod.overtimeId   || mod.id || mod.overtime_id,
      overTimeName:      mod.overTimeName  || mod.overtimeName || mod.overtime_name || mod.name,
      settings,
      assignedEmployees,
    };
  });
};

// ─── Main Component ───────────────────────────────────────────
const OvertimeSettings = () => {
  const dispatch = useDispatch();
  const commonState = useSelector(state => state.common);

  const [modules, setModules] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingModule, setEditingModule] = useState(null);
  const [editModuleName, setEditModuleName] = useState("");
  const [editNameError, setEditNameError] = useState("");
  const [assigningModule, setAssigningModule] = useState(null);
  const [newModuleName, setNewModuleName] = useState("");
  const [nameError, setNameError] = useState("");
  const [createStep, setCreateStep] = useState(1);
  const [pendingName, setPendingName] = useState("");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const pendingFetchType = useRef(null);
  const user = JSON.parse(localStorage.getItem("user_data")) || { user_id: 2 };
  const baseUrl = (process.env.REACT_APP_BASE_URI || "").replace(/\/$/, "");

  // ── fetchEmployees via Redux (employees endpoint works fine) ──
  const fetchEmployees = useCallback(() => {
    pendingFetchType.current = "employees";
    dispatch(commonGetDataFourth(getStaffListPath(user.user_id, 0, 0, 0)));
  }, [dispatch, user.user_id]);

  // ── fetchOvertimeList via DIRECT AXIOS ────────────────────────
  // ── fetchOvertimeList via DIRECT AXIOS ────────────────────────
  // ── fetchOvertimeList via DIRECT AXIOS ────────────────────────
  // ── fetchOvertimeList via DIRECT AXIOS ────────────────────────
  const fetchOvertimeList = useCallback(async () => {
    setLoading(true);
    pendingFetchType.current = "overtime";

    const base = (process.env.REACT_APP_BASE_URI || "").replace(/\/$/, "");
    const url = `${base}/${getOvertimeListPath(user.user_id)}`;

    console.log("Fetching from URL:", url);

    const userData = JSON.parse(localStorage.getItem("user_data") || "{}");
    const token = userData?.token || userData?.access_token ||
      localStorage.getItem("token") ||
      localStorage.getItem("access_token") || "";

    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        validateStatus: () => true,
      });

      console.log("Response status:", response.status);
      console.log("Response data:", response.data);

      const status = response.status;
      const res = response?.data;
      const msg = String(res?.message || "").toLowerCase();

      if (
        status === 404 ||
        res?.status === false ||
        msg.includes("no overtime") ||
        msg.includes("not found") ||
        msg.includes("no record")
      ) {
        setModules([]);
        setLoading(false);
        fetchEmployees();
        return;
      }

      // Handle different response structures
      let list = [];
      if (res?.data && Array.isArray(res.data)) {
        list = res.data;
      } else if (Array.isArray(res)) {
        list = res;
      } else if (res?.result && Array.isArray(res.result)) {
        list = res.result;
      }

      console.log("Extracted list:", list);

      if (list.length === 0) {
        setModules([]);
        setLoading(false);
        fetchEmployees();
        return;
      }

      const parsedModules = parseModules(list);
      console.log("Parsed modules:", parsedModules);
      setModules(parsedModules);
      setLoading(false);
      fetchEmployees();

    } catch (err) {
      console.error("Fetch error:", err);
      toast.error("Network error. Please check your connection.");
      setLoading(false);
    }
  }, [user.user_id, fetchEmployees]);
  // ── Initial load ──────────────────────────────────────────────
  useEffect(() => {
    if (user?.user_id) fetchOvertimeList();
    else toast.error("User ID not found. Please login again.");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Handle GET responses — only employees now ─────────────────
  // Overtime list now uses direct axios above, not Redux
  useEffect(() => {
    if (commonState.commonGetFourthSuccess) {
      if (assigningModule) return; // AssignModal handles its own response

      if (pendingFetchType.current === "employees") {
        const raw = commonState.commonGetFourthData;
        const list = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.data)
            ? raw.data
            : [];

        const normalised = list.map(emp => ({
          employeeId: String(emp.staff_id || emp.staffId || emp.employeeId || emp.employee_id || emp.id || ""),
          name: emp.full_name || emp.name || emp.employeeName || "Unknown",
          staffId: emp.staff_id || emp.staffId,
          full_name: emp.full_name || emp.name,
        })).filter(e => e.employeeId !== "");

        setEmployees(normalised);
        dispatch(initCommonState());
      }
    }

    if (commonState.commonGetFourthError && !assigningModule) {
      if (pendingFetchType.current === "employees") {
        toast.error(commonState.commonGetFourthMessage || "Failed to fetch employees");
      }
      setLoading(false);
      dispatch(initCommonState());
    }
  }, [
    commonState.commonGetFourthSuccess,
    commonState.commonGetFourthError,
    commonState.commonGetFourthMessage,
    commonState.commonGetFourthData,
    dispatch,
    assigningModule,
  ]);

  // ── Handle POST responses ─────────────────────────────────────
  useEffect(() => {
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage || "Operation successful");
      setShowCreateModal(false);
      setEditingModule(null);
      setEditModuleName(""); setEditNameError("");
      setNewModuleName(""); setCreateStep(1);
      dispatch(initCommonState());
      fetchOvertimeList();
    }
    if (commonState.commonError) {
      const msg = commonState.commonMessage || "";
      if (msg.includes("already exists")) {
        toast.error("An overtime module with this name already exists. Please use a different name.");
      } else if (msg.includes("does not exist")) {
        toast.error("Overtime module not found. Please refresh and try again.");
      } else if (msg.includes("Duplicate entry") && msg.includes("PRIMARY")) {
        toast.error("Database error. Contact administrator.");
      } else if (msg === "Forbidden") {
        toast.error("Access denied.");
      } else {
        toast.error(msg || "Operation failed");
      }
      dispatch(initCommonState());
    }
  }, [commonState.commonSuccess, commonState.commonError, commonState.commonMessage, dispatch, fetchOvertimeList]);

  // ── Handlers ──────────────────────────────────────────────────
  const openCreate = () => { setShowCreateModal(true); setCreateStep(1); setNewModuleName(""); setNameError(""); };

  const handleCreateNext = () => {
    if (!newModuleName.trim()) { setNameError("Module name is required"); return; }
    if (newModuleName.trim().length < 3) { setNameError("Module name must be at least 3 characters"); return; }
    setPendingName(newModuleName.trim()); setCreateStep(2); setNameError("");
  };

  const handleCreateSave = async (overtimeData) => {
    try {
      const response = await axios.post(
        `${baseUrl}/${createOvertimePath}`,
        { userId: user.user_id, overTimeName: pendingName, overTimeData: overtimeData },
        axiosConfig
      );
      const res = response?.data;
      if (res?.status === true || res?.status === "true" || res?.code === 200) {
        toast.success(res?.message || "Overtime module created successfully");
        setShowCreateModal(false); setCreateStep(1); setNewModuleName("");
        // ── Small delay to let backend commit before fetching ──
        setTimeout(() => fetchOvertimeList(), 500);
      } else {
        toast.error(res?.message || "Failed to create overtime module");
      }
    } catch (err) {
      const code = err?.response?.status;
      const resBody = err?.response?.data;
      if (code === 409) {
        toast.error("An overtime module with this name already exists. Please use a different name.");
        setCreateStep(1);
      } else {
        toast.error(resBody?.message || err?.message || "Failed to create overtime module");
      }
    }
  };

  const handleEditSave = async (overtimeData) => {
    if (!editModuleName.trim()) { setEditNameError("Module name is required"); return; }
    if (editModuleName.trim().length < 3) { setEditNameError("Module name must be at least 3 characters"); return; }
    setEditNameError("");

    try {
      const response = await axios.post(
        `${baseUrl}/${updateOvertimePath}`,
        {
          userId: String(user.user_id),
          overTimeId: String(editingModule.overTimeId),
          overTimeName: editModuleName.trim(),
          overTimeData: overtimeData
        },
        axiosConfig
      );

      const res = response?.data;
      const isSuccess =
        res?.status === true ||
        res?.status === "true" ||
        (res?.code === 409 && typeof res?.message === "string" && res.message.includes("already exists"));

      if (isSuccess) {
        toast.success("Overtime settings updated successfully");
        setEditingModule(null); setEditModuleName(""); setEditNameError("");
        dispatch(initCommonState());
        fetchOvertimeList();
      } else if (res?.code === 404 || (typeof res?.message === "string" && res.message.includes("does not exist"))) {
        toast.error("Module not found. Please refresh and try again.");
      } else {
        toast.error(res?.message || "Update failed. Please try again.");
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Update failed");
    }
  };

  const handleAssignSave = (selectedIds) => {
    setModules(prev => prev.map(m =>
      m.overTimeId === assigningModule.overTimeId
        ? { ...m, assignedEmployees: selectedIds }
        : m
    ));
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this OT settings module?")) return;

    try {
      const formData = new URLSearchParams();
      formData.append("userId", String(user.user_id));
      formData.append("overTimeId", String(id));

      const response = await axios.post(
        `${baseUrl}/admin/deleteOvertime`,
        formData,
        { ...axiosConfig, headers: { ...axiosConfig?.headers, "Content-Type": "application/x-www-form-urlencoded" } }
      );

      const result = response?.data;
      if (result && (result.status === true || result.status === "true")) {
        toast.success(result.message || "Deleted successfully");
        fetchOvertimeList();
      } else {
        toast.error(result?.message || "Delete failed");
      }
    } catch (error) {
      if (error.response?.status === 404) {
        toast.error("Delete endpoint not found. Please check: admin/deleteOvertime");
      } else {
        toast.error(error?.response?.data?.message || error?.message || "Delete failed");
      }
    }
  };

  const handleBackClick = () => {
    if (window.history.length > 1) window.history.back();
    else window.location.href = "/dashboard";
  };

  const paged = modules.slice((page - 1) * rowsPerPage, page * rowsPerPage);

  return (
    <div className="ot-wrap">
      <ToastContainer position="top-right" autoClose={2000} className="toast-custom" />

      <div className="ot-header">
        <div className="ot-header-left">
          <button className="ot-back-btn" onClick={handleBackClick}><BackIcon /></button>
          <div className="ot-header-text">
            <h1 className="ot-title">Overtime Settings</h1>
            <p className="ot-subtitle">Configure and manage overtime modules for your organization.</p>
          </div>
        </div>
        <button className="ot-create-btn" onClick={openCreate}><PlusIcon /> Create OT Settings</button>
      </div>

      <div className="ot-table-wrap">
        <div className="ot-table-card">
          <table className="ot-table">
            <thead>
              <tr>
                <th className="ot-th" style={{ width: "70px", textAlign: "center" }}>S.No</th>
                <th className="ot-th">Module Name</th>
                <th className="ot-th" style={{ width: "160px", textAlign: "center" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan={3} className="ot-empty">Loading…</td></tr>
              ) : paged.length === 0 ? (
                <tr>
                  <td colSpan={3} className="ot-empty">
                    <div>📋</div>
                    <div style={{ marginTop: "8px", fontWeight: "500" }}>No OT modules yet</div>
                    <div style={{ marginTop: "4px", fontSize: "12px" }}>Click "Create OT Settings" to add one</div>
                  </td>
                </tr>
              ) : paged.map((mod, idx) => (
                <tr key={mod.overTimeId} className={idx % 2 === 0 ? "ot-tr-odd" : "ot-tr-even"}>
                  <td className="ot-td ot-td-muted" style={{ textAlign: "center", verticalAlign: "middle" }}>
                    {(page - 1) * rowsPerPage + idx + 1}
                  </td>
                  <td className="ot-td">
                    <div className="ot-td-name">{mod.overTimeName}</div>
                    {/* <AssignedAvatars assignedIds={mod.assignedEmployees} employees={employees} /> */}
                  </td>
                  <td className="ot-td" style={{ verticalAlign: "middle" }}>
                    <div className="ot-action-cell">
                      <button className="ot-btn-icon" title="Assign" onClick={() => setAssigningModule(mod)}><AssignIcon /></button>
                      <button
                        className="ot-btn-icon"
                        title="Edit"
                        onClick={() => {
                          console.log("🔍 EDIT CLICKED - Full module data:", mod);
                          console.log("🔍 EDIT CLICKED - Module settings:", mod.settings);
                          console.log("🔍 EDIT CLICKED - Module details:", mod.details);
                          console.log("🔍 EDIT CLICKED - Raw module:", JSON.stringify(mod, null, 2));
                          setEditingModule(mod);
                          setEditModuleName(mod.overTimeName || "");
                          setEditNameError("");
                        }}
                      >
                        <EditIcon />
                      </button>
                      <button className="ot-btn-icon ot-btn-delete" title="Delete" onClick={() => handleDelete(mod.overTimeId)}><DeleteIcon /></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {modules.length > 0 && (
            <Pagination total={modules.length} rowsPerPage={rowsPerPage} page={page}
              onPage={setPage} onRowsChange={val => { setRowsPerPage(val); setPage(1); }} />
          )}
        </div>
      </div>

      {/* Create Modal */}
      {showCreateModal && (
        <OTModal
          title={createStep === 1 ? "Create OT Settings Module" : `Configure: ${pendingName}`}
          onClose={() => { setShowCreateModal(false); setCreateStep(1); setNewModuleName(""); }}
        >
          {createStep === 1 ? (
            <div className="ot-create-step1">
              <p className="ot-hint">Give this overtime module a name before configuring its rules.</p>
              <label className="ot-section-title">Module Name</label>
              <input autoFocus
                className={`ot-name-input${nameError ? " error" : ""}`}
                value={newModuleName}
                onChange={e => { setNewModuleName(e.target.value); setNameError(""); }}
                onKeyDown={e => e.key === "Enter" && handleCreateNext()}
                placeholder="e.g. Night Shift OT, Weekend OT…"
              />
              {nameError && <p className="ot-error-msg">{nameError}</p>}
              <div className="ot-form-footer">
                <button className="ot-btn-cancel" onClick={() => { setShowCreateModal(false); setNewModuleName(""); }}>Cancel</button>
                <button className="ot-btn-save" onClick={handleCreateNext}>Next → Configure</button>
              </div>
            </div>
          ) : (
            <OTSettingsForm
              onSave={handleCreateSave}
              onCancel={() => { setShowCreateModal(false); setCreateStep(1); setNewModuleName(""); }}
            />
          )}
        </OTModal>
      )}

      {/* Edit Modal */}
      {editingModule && (
        <OTModal
          title={`Edit Module: ${editingModule.overTimeName}`}
          onClose={() => { setEditingModule(null); setEditModuleName(""); setEditNameError(""); }}
        >
          <div className="ot-edit-name-wrap">
            <label className="ot-section-title">Module Name</label>
            <input
              className="ot-name-input"
              value={editModuleName}
              readOnly
              style={{ opacity: 0.6, cursor: "not-allowed" }}
              title="Module name cannot be changed here"
            />
            <p style={{ fontSize: "11px", color: "#a0aec0", marginTop: "4px" }}>
              Module name is locked. Delete and recreate to rename.
            </p>
          </div>
          <OTSettingsForm
            initialData={editingModule.settings}
            onSave={handleEditSave}
            onCancel={() => { setEditingModule(null); setEditModuleName(""); setEditNameError(""); }}
          />
        </OTModal>
      )}

      {/* Assign Modal */}
      {assigningModule && (
        <AssignModal
          module={assigningModule}
          onClose={() => { setAssigningModule(null); dispatch(initCommonState()); }}
          onSave={handleAssignSave}
        />
      )}
    </div>
  );
};

export default OvertimeSettings;